import React from 'react';
import { IntroContentVideoWithCaption } from '../../types';
import styles from './styles.module.scss';

type VideoWithCaptionPropType = {
  videoUploadModels: any;
};
export const VideoWithCaption: React.FunctionComponent<VideoWithCaptionPropType> =
  ({ videoUploadModels }) => {
    const videoUploadModel = videoUploadModels[0];

    let vimeo =
      videoUploadModel.source === 'Vimeo' &&
      videoUploadModel.source !== null &&
      `https://player.vimeo.com/video/${videoUploadModel.videoUrl}`;
    const youtube =
      videoUploadModel.source === 'YouTube' &&
      videoUploadModel.source !== null &&
      `https://www.youtube.com/embed/${videoUploadModel.videoUrl}`;

    if (!('source' in videoUploadModel)) {
      vimeo =
        videoUploadModel.source !== null &&
        `https://player.vimeo.com/video/${videoUploadModel.videoUrl}`;
    }
    return (
      <div className={styles['video-with-caption']}>
        <figure>
          <div className={styles.iframeContainer}>
            {vimeo && <iframe src={vimeo} title={videoUploadModel.videoUrl} />}
            {youtube && (
              <iframe src={youtube} title={videoUploadModel.videoUrl} />
            )}
          </div>
          {/* {videoUploadModel.video_caption && (
            <figcaption>{videoUploadModel.video_caption}</figcaption>
            )} */}
        </figure>
      </div>
    );
  };
